import React, { useState, useEffect, useRef, useCallback } from "react";

const BeneficiaryCreditHistory = () => {
  return <div className="flex flex-direction-columnflex flex-column">TEST</div>;
};

export default BeneficiaryCreditHistory;
